var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 8.70977L13.6668 4.56177C13.1988 4.19768 12.6227 4 12.0298 4C11.4368 4 10.8608 4.19768 10.3928 4.56177L5.05879 8.70977C4.73823 8.95905 4.47888 9.2783 4.30054 9.64312C4.1222 10.0079 4.02959 10.4087 4.02979 10.8148V18.0148C4.02979 18.5452 4.2405 19.0539 4.61557 19.429C4.99064 19.8041 5.49935 20.0148 6.02979 20.0148H18.0298C18.5602 20.0148 19.0689 19.8041 19.444 19.429C19.8191 19.0539 20.0298 18.5452 20.0298 18.0148V10.8148C20.0298 9.99177 19.6498 9.21477 18.9998 8.70977Z",
    stroke: "#543D10",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15C13.79 16.333 10.208 16.333 8 15",
    stroke: "#543D10",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon2);
export default __webpack_public_path__ + "static/media/HomeIcon2.0cc64daf3a7c46324ce921274d303ad4.svg";
export { ForwardRef as ReactComponent };